import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    error: null,
    messagelistData: []
}
export const message = createSlice({
    name: 'message',
    initialState,
    reducers: {
        messageslistLoad: (state) => {
            state.loading = true
        },
        messageslistSuccess: (state, action) => {
            state.loading = false
            state.messagelistData = action.payload
        },
        messageslistFail: (state) => {
            state.loading = false
        },
    }
});

export const {
    messageslistLoad,
    messageslistSuccess,
    messageslistFail,
} = message.actions;
export default message.reducer;